import React, { useState, useRef } from 'react';
import { withStyles } from '@material-ui/core';
import { FileCopyOutlined as ContentCopyIcon } from '@material-ui/icons';
import Tooltip from '../../../common/StyledToolTip';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../appConfigContext';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%'
  },
  content: {
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  copyIcon: {
    cursor: 'pointer',
    padding: 5
  }
});

const TOOLTIPS = {
  beforeCopy: 'Copy text',
  afterCopy: 'Copied to clipboard'
};

const CopyTextCellRenderer = ({ classes, value, configJSON }) => {
  const [copyIconTooltip, setCopyIconTooltip] = useState(TOOLTIPS.beforeCopy);
  const timeoutRef = useRef(null);

  const stopEventPropagation = (e) => {
    e.stopPropagation();
  };

  const copyTextToClipboard = (e) => {
    stopEventPropagation(e);
    navigator.clipboard.writeText(value);

    setCopyIconTooltip(TOOLTIPS.afterCopy);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      // Reset the tooltip after 2 seconds
      setCopyIconTooltip(TOOLTIPS.beforeCopy);
    }, 2000);
  };

  return (
    <div className={classes.container}>
      <p className={classes.content} title={value}>
        {value}
      </p>

      {configJSON?.enableTextCopy && (
        <Tooltip title={copyIconTooltip}>
          <div
            aria-label="Copy text"
            className={classes.copyIcon}
            onClickCapture={copyTextToClipboard}
            // Prevent AG Grid from handling the click event
            onPointerDownCapture={stopEventPropagation}
            onMouseDownCapture={stopEventPropagation}
            onDoubleClickCapture={stopEventPropagation}>
            <ContentCopyIcon style={{ fontSize: 14 }} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default compose(withAppConfig, withStyles(styles))(CopyTextCellRenderer);
